<template>
<component
    :is="tagName"
    :class="['mdc-icon-button', svg ? $style.svg : 'material-icons']"
    :type="tagName === 'button' ? type : null"
    :disabled="disabled"
    :aria-label="label">
    <div class="mdc-icon-button__ripple"></div>
    <svg-icon
        v-if="svg"
        class="mdc-icon-button__icon"
        :name="icon" />
    <template v-else>{{ icon }}</template>
</component>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";

export default {
    components: { SvgIcon },
    props: {
        disabled: Boolean,
        svg: { type: Boolean, default: true },
        icon: { type: String, default: "" },
        label: { type: String, default: null },
        tagName: { type: String, default: "button" },
        type: { type: String, default: "button" }
    }
};
</script>

<style lang="scss" module>
.svg {
    line-height: 0;
}
</style>
